import rdylgnData from "./raw/rdylgn.json";

export const rdylgnColormap = (type) => {
  if (type === "range") {
    return rdylgnData;
  }
};
